// extracted by mini-css-extract-plugin
export default {"bookmark":"styles_bookmark__TRtwm","bookmark-inner":"styles_bookmark-inner__o8opX","hide":"styles_hide__17Vzn","appearance":"styles_appearance__Gs6iu"};